// extracted by mini-css-extract-plugin
export default {"notification-list":"NotificationsList_notification-list__bkvFz","notification-list--empty":"NotificationsList_notification-list--empty__d5Ofs"};